import { createReducer } from '@reduxjs/toolkit' ;
import {  getClearResponse,  getIacmLocationSuccess, getIacmLocationFailure, getIacmActivateLocationSuccess, getIacmActivateLocationFailure, toggleLeftPanel} from '../actions/checkmateAuthorizationAction';

const initialState = {
    loading: false,
    storeLocation: {},
    storeLocationError: {},
    activateLocation: {},
    activateLocationError: {},
    locationActivationComplete: false,
    toggleLeftPanel: true,
}


const checkmateAuthorizationReducer = createReducer(initialState, (builder) => {
    builder
          .addCase(getClearResponse, (state) => {
            state.activateLocation = {};
            state.storeLocation = {};
            state.locationActivationComplete = false;
        }).addCase(getIacmLocationSuccess, (state, action) => {
            state.loading = false;
            state.storeLocation = action.payload.response?.data || action.payload.response?.response.data.message || {};
        }).addCase(getIacmLocationFailure, (state, action) => {
            state.loading = false;
            state.storeLocation = {msg: 'ERROR'};
        }).addCase(getIacmActivateLocationSuccess, (state, action) => {
            state.loading = false;
            state.activateLocation= action.payload.response;
        }).addCase(getIacmActivateLocationFailure, (state, action) => {
            state.loading = false;
            state.activateLocation = {msg: 'ERROR'};
        }).addCase(toggleLeftPanel, (state, action)=> {
            state.toggleLeftPanel = action.payload.response;
        })
          .addDefaultCase(() => { });
});
export default checkmateAuthorizationReducer;



